import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import {
  selectAseIsEditable,
  selectAseIsOnline,
} from 'store/assessments/selectors';

import { SummaryDisplay } from './PagesMain/SummaryDisplay';
import { SummaryEdit } from './PagesMain/SummaryEdit';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ASSESSMENT],
  Screens.ASE_SUMMARY
>;

export const SummaryScreen: React.FC<Props> = ({ navigation, route }) => {
  const isEditable = useSelector(selectAseIsEditable);
  const isOnline = useSelector(selectAseIsOnline);
  return isEditable && !isOnline ? (
    <SummaryEdit navigation={navigation} route={route} />
  ) : (
    <SummaryDisplay navigation={navigation} route={route} />
  );
};
